<template>
  <SlotSwitcher
    :active-index="getSlotSwitcherIndex"
    global
    :loading="loading"
    @toggle="toggle"
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />
  </SlotSwitcher>
</template>

<script>
// vuex
import { mapActions, mapGetters } from 'vuex'
// components
import SlotSwitcher from '@/components/switchers/gl-slot-switcher'

export default {
  name: 'GlobalSlotSwitcher',
  components: { SlotSwitcher },
  data() {
    return { loading: false }
  },
  computed: {
    ...mapGetters('common', ['getSlotSwitcherIndex']),
  },
  watch: {
    getSlotSwitcherIndex() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 600)
    },
  },
  methods: {
    ...mapActions('common', ['updateSlotSwitcherIndex']),
    toggle() {
      const slotCount = Object.keys(this.$slots).filter(name =>
        name.startsWith('item-'),
      ).length

      const newIndex = (this.getSlotSwitcherIndex + 1) % slotCount
      this.updateSlotSwitcherIndex(newIndex)
    },
  },
}
</script>
